<div class="row">
  <div class="col-12">
    <div class="dp-hidden position-absolute">
      <div class="input-group">
        <input
          name="datepicker"
          class="form-control"
          ngbDatepicker
          #datepicker="ngbDatepicker"
          [autoClose]="'outside'"
          (dateSelect)="onDateChanged($event)"
          [displayMonths]="2"
          [dayTemplate]="t"
          outsideDays="hidden"
          [startDate]="ngbDateFrom!"
          tabindex="-1"/>
        <ng-template #t let-date let-focused="focused">
                    <span
                      class="custom-day"
                      [class.focused]="focused"
                      [class.range]="isRange(date)"
                      [class.faded]="isHovered(date) || isInside(date)"
                      (mouseenter)="hoveredDate = date"
                      (mouseleave)="hoveredDate = null">
                      {{ date.day }}
                    </span>
        </ng-template>
      </div>
    </div>
    <div class="input-group dk-input-30">
      <input
        #dpFromDate
        class="form-control calendar-date"
        name="dpFromDate"
        placeholder="From"
        [value]="formatNgDate(ngbDateFrom)"
        (change)="validateDateInput('ngbDateFrom', dpFromDate.value)"
      />
      <input
        #dpToDate
        class="form-control calendar-date"
        name="dpToDate"
        placeholder="To"
        [value]="formatNgDate(ngbDateTo)"
        (change)="validateDateInput('ngbDateTo', dpToDate.value)"
      />
      <div class="input-group-append">
        <button class="btn input-group-text" (click)="datepicker.toggle()" type="button">
          <i class="fa fa-calendar"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="col-12">
  </div>
</div>
